
import React, { useEffect, useState } from 'react';
import { getLstExamSvc } from './questionPaperSvc';
import "./questionPaper.css";

const ExamHeader = (props) => {
    const [examId, setExamId] = useState(props.examId);
    const [lstExam, setLstExam] = useState([]);
    const [dynamicWidth, setDynamicWidth] = useState('calc(100% / ' + 9 + ')');

    useEffect(() => {
        setExamId(props.examId);
        getLstExamSvc(cbLstExamResponse);
    }, []);

    function cbLstExamResponse(data) {
        if (data.SvcStatus === 'Success') {
            setLstExam(data.lstExam);
            setDynamicWidth('calc(100% / ' + data.lstExam.length + ')');
            props.changeExam(data.lstExam[0]);
        }
    }

    return (
        <div className="col-sm-12 col-centered padding-remove" >
            <div className="col-sm-9 padding-remove" >
                <div className="wrapper-box-pattern-subject">
                    {lstExam.map((obj) => {
                        const isSelected = obj.examId === props.examId;
                        return (
                            <div
                                className={isSelected ? 'selected exam-block-pattern-subject' : 'exam-block-pattern-subject'}
                                onClick={() => props.changeExam(obj)}
                                key={obj.examId}
                                style={{
                                    border: isSelected ? '2px solid #007bff' : '1px solid #ccc',
                                }}
                            >
                                <div className="exam-name-subject">{obj.exam}</div>
                                <div className="exam-dates-subject">{obj.fromDt} - {obj.toDt}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ExamHeader;
